/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { menuState } from "./menu.state";

const menu = createSlice({
    
    name: "menu",
    
    initialState: menuState,
    
    reducers: {
    
        activeItem (state, action) {
            state.openItem = action.payload.openItem;
        },

        activeComponent (state, action) {
            state.openComponent = action.payload.openComponent;
        },

        openDrawer (state, action) {
            state.drawerOpen = action.payload.drawerOpen;
        },

        openComponentDrawer (state, action) {
            state.componentDrawerOpen = action.payload.componentDrawerOpen;
        },
    
    },
});

export const menuReducer = menu.reducer;

export const {
    activeItem,
    activeComponent,
    openDrawer,
    openComponentDrawer
} = menu.actions;
